import React, {useEffect} from 'react';
import {MainList} from './components';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';


import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Container from '@material-ui/core/Container';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ExistToAppIcon from '@material-ui/icons/ExitToApp';

import {Copyright} from '../../components'

import { withRouter } from "react-router";

import { logoutUser } from '../../services/auth.service';
import { useAuth } from "../../context/auth";
import {LOCAL_STORAGE_KEYS} from "../../utils/constants";

const drawerWidth = 275;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        height: '100vh',
        overflow: 'hidden',
    },
    paper: {
        marginRight: theme.spacing(2),
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    user_email: {
        flexGrow: 1,
        textAlign: "right",
        cursor: 'pointer'
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        height: '100vh',
        overflowY: 'auto',
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        minHeight: 'calc(100vh - 64px)',
        display: 'flex',
        flexDirection: 'column',
    },
    copyrightBox: {
        marginTop: 'auto',
        paddingTop: theme.spacing(4),
    },
}));

// - List
// - Accounts
// - Config
// - Subscriptions
// - Area UI Conf
// - Badge UI Conf
// - All Areas
// - All Badges

const pathToLabelHeadMap = {
    'home': 'Dashboard',
    'surveys__list': 'Surveys',
    'partner_requests__list': 'Partner Requests',
    'emails__list': 'Email Log',
    'surveys__edit': 'Edit Survey Text | Surveys',
    'surveys__responses': 'Responses | Surveys',
    'password__change': 'Change Password',
    'ui_config': 'UI Configs',

    'meta_data__assess8': 'Assess-8 | Meta-Data',
    'meta_data__level3': 'Level-5 | Meta-Data',
    'meta_data__level6': 'Level-6 | Meta-Data',
    'meta_data__level7': 'Level-7 | Meta-Data',
    'meta_data__level9': 'Level-9 | Meta-Data',
    'meta_data__v3_level1_area': 'Level-1 Area | Meta-Data',
    'meta_data__v3_level2_stakeholder': 'Level-2 Stakeholder | Meta-Data',
    'meta_data__v3_level3_dimension': 'Level-3 Dimension | Meta-Data',
    'meta_data__v3_level5_competency': 'Level-5 Competency | Meta-Data',
    'meta_data__v3_level7_dq_code': 'Level-7 DQ Code | Meta-Data',
    'meta_data__v3_level8_unit': 'Level-8 Unit | Meta-Data',
    'meta_data__v3_level9_session': 'Level-9 Session | Meta-Data',
    'meta_data__v3_level10_element': 'Level-10 Element | Meta-Data',
    'meta_data__v3_level11_rubric': 'Level-11 Rubric | Meta-Data',
    'meta_data__v3_instrument_bank': 'Instrument Bank | Meta-Data',
    'meta_data__cat4': 'Category-4 | Meta-Data',
    'meta_data__cat11': 'Category-11 | Meta-Data',
    'meta_data__cat108': 'Category-108 | Meta-Data',
    'meta_data__packages': 'Packages | Meta-Data',
    'meta_data__dq_pro_plans': 'DQ PRO Plans | Meta-Data',
    'meta_data__assess8_translation': 'Assess-8 | Translations',
    'meta_data__level3_translation': 'Level-5 | Translations',
    'meta_data__level6_translation': 'Level-6 | Translations',

    'org__list': 'List | Organizations',
    'org__accounts': 'Accounts | Organizations',
    'org__orders': 'Orders | Organizations',
    'org__allorders': 'Orders | Pending',
    'org__configs': 'Configs | Organizations',
    'org__subscriptions': 'Subscriptions | Organizations',
    'org__sections': 'Sections | Organizations',
    'org__profile_lookup': 'Profile Lookup | Organizations',
    'org__area_ui_conf': 'Area UI Conf | Organizations',
    'org__badge_ui_conf': 'Badge UI Conf | Organizations',
    'org__all_areas': 'All Areas | Organizations',
    'org__all_badges': 'All Badges | Organizations',
    'org__all_packages': 'ALl Packages | Organizations',
    'org__pbdq_payment': 'Payment | PBDQ',
    'org__pbdq_list': 'PBDQS List | PBDQ',
    'org__pbdq_plans': 'Plans | PBDQ',
    'org__pbdq_products': 'Products | PBDQ',
    'org__pbdq_signup_applications': 'Sign-up Applications | PBDQ',

    'dqcr_tool__dashboard': 'Dashboard | DQ-Creator Tool',
    // 'insider__dq_modules': 'DQ Modules | Insider',
    'dqcr_tool__jobs': 'Creation Jobs | DQ-Creator Tool',
    'dqcr_tool__quick_create': 'Quick Create | DQ-Creator Tool',
    'dqcr_tool__interactive_create': 'Interactive Create | DQ-Creator Tool',
    'dqcr_tool__view_and_edit': 'View & Edit | DQ-Creator Tool',
    // 'insider__list_org': 'List | Organizations',
    // 'insider__list_org_modules': 'List | Org Modules',

    'users__list' : 'List | Users',
    'settings__configs': 'Configs | Settings',
    'settings__builds': 'Builds | Settings'
};


const Main = props => {
    const { children, history, location } = props;
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);
    const [labelHeading, setLabelHeading] = React.useState('Dashboard');
    const { setAuthToken, setAuthUser, authUser } = useAuth();

    const [pathKey, setPathKey] = React.useState('home');

    const anchorRefUserMenu = React.useRef(null);
    const [openUserMenu, setOpenUserMenu] = React.useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };

    const handleUserMenuToggle = () => {
        setOpenUserMenu((prevOpen) => !prevOpen);
    };

    const handleUserMenuClose = (event) => {
        if (anchorRefUserMenu.current && anchorRefUserMenu.current.contains(event.target)) {
            return;
        }

        setOpenUserMenu(false);
    };

    const handleChangePassword = (event) => {
        handleUserMenuClose(event);
        history.push('/password/change');
    }

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpenUserMenu(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevUserMenuOpen = React.useRef(openUserMenu);
    React.useEffect(() => {
        if (prevUserMenuOpen.current === true && openUserMenu === false) {
            anchorRefUserMenu.current.focus();
        }

        prevUserMenuOpen.current = openUserMenu;
    }, [openUserMenu]);

    const handleLogout = async () => {
        try {
            await logoutUser();
            setAuthToken(null);
            setAuthUser(null);
            localStorage.clear();
            // history.push('/login');
        } catch (e) {
            // already toasted the error
        }
    };

    useEffect( ()=>{

        const path_parts = location.pathname.split('/');
        console.log('path_parts --> ', path_parts)
        if (path_parts.length > 1) {
            if (path_parts.length < 3) {
                const path_key = path_parts[1];
                if (pathToLabelHeadMap[path_key]) {
                    setLabelHeading(pathToLabelHeadMap[path_key]);
                    setPathKey(path_key);
                }
            } else {
                const path_key = `${path_parts[1]}__${path_parts[2]}`;
                if (pathToLabelHeadMap[path_key]) {
                    setLabelHeading(pathToLabelHeadMap[path_key]);
                    setPathKey(path_key);
                }
            }
        }

    },[location]);

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
                <Toolbar className={classes.toolbar}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                        {labelHeading}
                    </Typography>

                    <div >
                        <Typography
                            ref={anchorRefUserMenu}
                            aria-controls={openUserMenu ? 'menu-list-grow' : undefined}
                            aria-haspopup="true"
                            onClick={handleUserMenuToggle}
                            color="inherit" noWrap className={classes.user_email}>{authUser.email}
                        </Typography>
                        <Popper open={openUserMenu} anchorEl={anchorRefUserMenu.current} role={undefined} transition disablePortal>
                            {({ TransitionProps, placement }) => (
                                <Grow
                                    {...TransitionProps}
                                    style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                                >
                                    <Paper>
                                        <ClickAwayListener onClickAway={handleUserMenuClose}>
                                            <MenuList autoFocusItem={openUserMenu} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                                <MenuItem onClick={handleChangePassword}>Change Password</MenuItem>
                                                <MenuItem onClick={handleLogout}>Logout</MenuItem>
                                            </MenuList>
                                        </ClickAwayListener>
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </div>

                    <IconButton color="inherit" onClick={handleLogout}>
                        <ExistToAppIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Drawer
                variant="permanent"
                classes={{
                    paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
                }}
                open={open}
            >
                <div className={classes.toolbarIcon}>
                    <IconButton onClick={handleDrawerClose}>
                        <ChevronLeftIcon />
                    </IconButton>
                </div>
                <Divider />
                <MainList path={pathKey} logoutAction={handleLogout} />
            </Drawer>
            <main className={classes.content}>
                <div className={classes.appBarSpacer} />
                <Container maxWidth="false" className={classes.container}>
                    {children}
                    <Box className={classes.copyrightBox}>
                        <Copyright />
                    </Box>
                </Container>
            </main>
        </div>
    );
}

export default withRouter(Main);